import angular from 'angular';
import { postActionsComponent } from './postActionsComponent';

angular
	.module('sh.postActions', [
		'sh.api',
		'sh.cfg',
		'sh.postService',
		'sh.modal',
		'sh.identity',
		'sh.attService',
		'sh.clickToDownload',
	])
	.component('shPostActions', postActionsComponent());
